module.exports = __webpack_public_path__ + "./images/555c2d49eb54d3902cf4051e82b206f8.webp";